/* Makeloo V4 — In-place (AJAX) layer filtering.
   Progressive enhancement over the server-rendered engine (v4-layer-band.liquid):
   intercepts filter / sort / pagination navigations inside the collection section and
   swaps only that section, preserving scroll and browser history. The engine is never
   changed; its full-URL links stay the no-JS fallback. */
(function () {
  'use strict';
  if (window.__v4AjaxFilters) { return; }
  window.__v4AjaxFilters = true;

  var rootId = null;      // id of the swapped section (stable across pages)
  var controller = null;  // aborts an in-flight fetch when a newer one starts

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function getRoot() { return rootId ? document.getElementById(rootId) : null; }

  /* Re-create <script> tags so they execute on the freshly swapped DOM
     (inserted nodes never auto-run their scripts). Skips this loader. */
  function runScripts(container) {
    container.querySelectorAll('script').forEach(function (old) {
      if (old.hasAttribute('data-v4-ajax-loader')) { return; }
      var s = document.createElement('script');
      for (var i = 0; i < old.attributes.length; i++) {
        s.setAttribute(old.attributes[i].name, old.attributes[i].value);
      }
      if (old.src) { s.src = old.src; } else { s.textContent = old.textContent; }
      old.parentNode.replaceChild(s, old);
    });
  }

  function afterSwap(root) {
    document.body.style.overflow = '';           // release any drawer scroll-lock
    runScripts(root);                            // re-bind band reveal + drawer toggle
  }

  /* Scroll must run AFTER the swap+transition settles: scrollTo() is suppressed while a
     View Transition captures its snapshot, so calling it inside the update callback is a no-op. */
  function scrollToGridTop(root) {
    var grid = root.querySelector('.v4-col-grid__products, .v4-cg-grid__products') || root;
    var top = grid.getBoundingClientRect().top + window.pageYOffset - 80;
    // 'auto' (instant): the storefront's smooth-scroll layer swallows programmatic
    // smooth scrolls, so 'smooth' is a silent no-op here. Instant always lands.
    window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
  }

  function navigate(url, push, scrollToGrid) {
    var root = getRoot();
    if (!root) { window.location.href = url; return; }
    if (controller) { controller.abort(); }
    controller = new AbortController();
    var signal = controller.signal;
    var lel = root.querySelector('.v4-col-body, .v4-cg-body');
    if (lel) { lel.classList.add('is-loading'); }
    if (push) { history.pushState({ v4ajax: true }, '', url); }

    fetch(url, { signal: signal, headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (signal.aborted) { return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(rootId);
        var current = getRoot();
        if (!fresh || !current) { window.location.href = url; return; } // shape changed -> full nav
        var node = document.importNode(fresh, true);
        var swap = function () {
          current.parentNode.replaceChild(node, current);
          afterSwap(node);
        };
        var afterScroll = function () { if (scrollToGrid) { scrollToGridTop(node); } };
        if (document.startViewTransition && !reduced()) {
          // A newer navigation skips an in-flight transition, which rejects its
          // promises with InvalidStateError; the DOM swap still runs. Swallow the
          // rejections so overlapping filter clicks never surface console errors.
          var vt = document.startViewTransition(swap);
          ['ready', 'updateCallbackDone'].forEach(function (k) {
            if (vt && vt[k] && vt[k].catch) { vt[k].catch(function () {}); }
          });
          vt.finished.then(afterScroll).catch(afterScroll); // scroll once the transition settles
        } else {
          swap();
          requestAnimationFrame(afterScroll);
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') { return; }
        window.location.href = url;               // network/parse failure -> full nav
      });
  }

  /* A link is interceptable only when it stays on the exact same collection path
     (filter/trail/clear/pagination differ by query string only). Product cards,
     breadcrumbs, "← Boutique" and recipe/tag chips change pathname -> browser handles them. */
  function sameCollectionUrl(href) {
    var url;
    try { url = new URL(href, location.href); } catch (e) { return null; }
    if (url.origin !== location.origin) { return null; }
    if (url.pathname !== location.pathname) { return null; }
    return url;
  }

  // ---- Clicks: layer cards, trail chips, "Effacer tout", pagination ----
  document.addEventListener('click', function (e) {
    if (!rootId || e.defaultPrevented) { return; }
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    var a = e.target.closest('a');
    if (!a || !a.href) { return; }
    if (a.target && a.target !== '_self') { return; }
    var root = getRoot();
    if (!root || !root.contains(a)) { return; }
    var url = sameCollectionUrl(a.href);
    if (!url) { return; }
    var isPage = !!a.closest('.v4-col-pagination, .v4-cg-pagination');
    e.preventDefault();
    navigate(url.toString(), true, isPage);
  });

  // ---- Submit: the filter drawer form (a real submit event fires) ----
  document.addEventListener('submit', function (e) {
    if (!rootId) { return; }
    var form = e.target;
    var root = getRoot();
    if (!root || !root.contains(form)) { return; }
    if ((form.method || 'get').toLowerCase() !== 'get') { return; }
    var action = form.getAttribute('action') || location.pathname;
    var url;
    try { url = new URL(action, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) { return; }
    url.search = new URLSearchParams(new FormData(form)).toString();
    e.preventDefault();
    navigate(url.toString(), true, false);
  });

  // ---- Change (capture): sort <select>. Its inline onchange calls form.submit(),
  //      which dispatches NO submit event, so intercept in the capture phase before it runs. ----
  document.addEventListener('change', function (e) {
    if (!rootId) { return; }
    var sel = e.target;
    if (!sel.matches || !sel.matches('select[name="sort_by"]')) { return; }
    var form = sel.form;
    var root = getRoot();
    if (!form || !root || !root.contains(form)) { return; }
    e.preventDefault();
    e.stopImmediatePropagation();                // block inline this.form.submit()
    var action = form.getAttribute('action') || location.pathname;
    var url = new URL(action, location.href);
    url.search = new URLSearchParams(new FormData(form)).toString();
    navigate(url.toString(), true, false);
  }, true);

  // ---- Back / forward: swap without pushing a new entry ----
  window.addEventListener('popstate', function () {
    if (!rootId) { return; }
    navigate(location.href, false, false);
  });

  // ---- Activate only where the layer engine is present ----
  function init() {
    var band = document.querySelector('.v4-lay');
    if (!band) { return; }
    var root = band.closest('[id^="shopify-section-"]');
    if (root && root.id) {
      rootId = root.id;
      // We own scroll for our pushState/popstate swaps; stop the browser from racing us to 0.
      if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
